<template>
  <div>
    <!--      only one component-->
    <div v-if="componentsLength === 1" class="mx-6 my-4">

      <div class="b-full-table__inner mt-4 mr-3">
        <div class="b-full-table__row b-full-table__row-header">
          <div class="b-full-table__cell b-full-table__header-cell">{{ $tc('CONTENT.payments.payment', 1) }}</div>
          <div class="b-full-table__cell b-full-table__header-cell">{{ $t('CONTENT.payments.payment_date') }}</div>
          <div class="b-full-table__cell b-full-table__header-cell">{{ $t('CONTENT.payments.payment_first_date') }}</div>
          <div class="b-full-table__cell b-full-table__header-cell">{{ $t('CONTENT.payments.payment_frequency') }}</div>
          <div class="b-full-table__cell b-full-table__header-cell">{{ $t('CONTENT.indexation.indexation') }}</div>
          <div class="b-full-table__cell b-full-table__header-cell">{{ $t('CONTENT.payments.discountRateForCell') }}
          </div>
          <div class="b-full-table__cell b-full-table__header-cell b-full-table__cell_type_edit"
               v-if="isContractRawEditing && notVirtualPaymentsLength > 1"></div>
        </div>
        <div v-for="lessor in assetComponent.lessorComponentShares"
             class="b-contract__card-data-lessor"
             :class="{ 'b-contract__card-data-lessor--red': lessor.isRemove }">
          <div class="row pb-2">
            <div class="col-11 pt-2">
                <div class="b-contract__card-data-lessor-name">{{ $t('CONTENT.payments.payments_for_lessor') }}:
                  <span class="b-contract__card-data-lessor-name--gray">{{ getLesseeName(lessor.lessorId) }}</span>
                  <button
                    v-if="lessor.isNew && !lessor.paymentsParameters.length && isContractEventState"
                    type="button"
                    class="b-btn b-btn_border_none b-btn--right"
                    @click="removeLessorForEvent(lessor)">
                    <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="delete"></dynamic-icon>
                  </button>
                  <div class="b-contract__secondary-text" v-if="!isContractRawEditing && !(isContractEventState && lessor.isNew) && lessor.externalId!==null">{{ $t("CONTENT.assets.lessorShareExternalId") }}: {{lessor.externalId}}</div>
                  <div class="row pt-2" v-if="isContractRawEditing || (isContractEventState && lessor.isNew)">
                    <div class="col-4">
                      <label>{{ $t("CONTENT.assets.lessorShareExternalId") }}</label>
                      <input type="text" class="b-input" v-model="lessor.externalId" @blur="onLessorComponentShareUpdated"/>
                    </div>
                  </div>
                </div>
            </div>
            <div class="col-1">
              <button type="button" class="b-btn b-btn_border_none ml-auto" @click="()=>removeAssetLessor(lessor.lessorId)" v-if="isContractRawEditing && !isSingleLessorAsset">
                <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="delete"/>
              </button>
            </div>
          </div>
          <div class="b-contract__card-data-payment" v-for="payment in sortedByFirstPaymentDate(lessor.paymentsParameters)" :key="payment.idInDb">
            <PaymentTableRow
              :payment="payment"
              :assetComponent="assetComponent"
              :lessorComponentShare="lessor"
              :notVirtualPaymentsLength="notVirtualPaymentsLength"
              :unitOfMeasure="getUnitOfMeasureName(assetComponent.unitOfMeasureCode)"/>
          </div>
          <div class="mt-3 mb-1 ml-10" v-if="(isContractRawEditing || (isContractEventState && lessor.isNew))">
            <button type="button" class="b-btn" @click.prevent="addNewPayment(assetComponent.idInDB, lessor)">
              <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
              {{ $tc('CONTENT.payments.payment_create_for_lessor') }}
            </button>
          </div>
          <div class="b-contract_row_flex-end mt-3 mb-1 ml-10 pr-10" v-if="isContractEventState">
            <button
              v-if="!lessor.isEditForEvent && lessor.paymentsParameters.length && !lessor.isNew && !lessor.isRemove"
              type="button"
              class="b-btn end"
              :disabled="lessor.isNotChanges"
              @click="editPaymentsForEvent(lessor)">
              {{ $tc('CONTENT.payments.payments_edit_event') }}
            </button>
            <button
              v-if="lessor.isEditForEvent && lessor.paymentsParameters.length && !lessor.isNew && !lessor.isRemove"
              type="button"
              class="b-btn b-btn--green end"
              @click="acceptPaymentsForEvent(lessor)">
              {{ $tc('CONTENT.payments.payments_accept_event') }}
            </button>
            <checkbox
              v-if="lessor.paymentsParameters.length && !lessor.isNew && !lessor.isRemove"
              class="b-checkbox ml-5 mr-10"
              :disabled="lessor.isEditForEvent"
              v-model="lessor.isNotChanges"
              @change="changedIsNotChanges(lessor)"
            ><span class="text-bold">{{$t('CONTENT.payments.payments_not_changes')}}</span></checkbox>
          </div>
        </div>
      </div>

      <!--        manualChartPayments-->
      <div v-for="lessor in assetComponent.lessorComponentShares">
        <div v-if="lessor.manualChartPayments.length > 0" class="mt-4">
        <span class="b-contract__card-data-lessor-name">{{ $t('CONTENT.payments.payments_for_lessor') }}:
          <span class="b-contract__card-data-lessor-name--gray">{{ getLesseeName(lessor.lessorId) }}</span>
        </span>
          <div class="b-full-table_type_short my-4 mx-3">
            <div class="b-full-table__row b-full-table__row-header">
              <div class="b-full-table__cell b-full-table__header-cell b-table__cell_width_md">
                {{ $tc('CONTENT.payments.payment', 1) }}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-table__cell_width_md">
                {{ $t('CONTENT.discountRates.discount_rate') }}
              </div>
            </div>
            <div v-for="manualChartPayment in lessor.manualChartPayments">
              <ManualChartPaymentTableRow :manualChartPayment="manualChartPayment"/>
            </div>
          </div>
        </div>
      </div>

      <!--      options-->
      <div class="col-8 px-4 mt-4 py-4 b-full-table__assets-info-wrap"
           v-if="assetComponent.buyout !== null && assetComponent.buyout.paymentDate !== null || assetComponent.termination !== null && assetComponent.termination.paymentDate !== null">
        <div class="b-contract__card-data-info-about-wrap"
             :class="{'mb-2': assetComponent.termination !== null && assetComponent.termination.paymentDate !== null}"
             v-if="assetComponent.buyout !== null && assetComponent.buyout.paymentDate !== null">
          <div class="row b-form__container_type_flex">
            <div class="col-2 b-contract__card-data-info-about-row-name mb-1">{{ $t('CONTENT.assets.buyout') }}</div>
            <div class="col-2 b-contract__card-data-info-about-row-name mb-1">
              {{ $t('CONTENT.payments.payment_date') }}
            </div>
          </div>
          <div class="row">
            <div class="col-2">{{ assetComponent.buyout.rate }} {{ assetComponent.buyout.currencyCode }}</div>
            <div class="col-2">{{ getBuyoutDate(assetComponent) }}</div>
          </div>
        </div>
        <div
          class="b-contract__card-data-info-about-wrap"
          v-if="assetComponent.termination !== null && assetComponent.termination.paymentDate !== null"
        >
          <div class="row b-form__container_type_flex">
            <div class="col-2 b-contract__card-data-info-about-row-name mb-1">{{ $t('CONTENT.assets.termination') }}
            </div>
            <div class="col-2 b-contract__card-data-info-about-row-name mb-1">
              {{ $t('CONTENT.payments.payment_date') }}
            </div>
          </div>
          <div class="row">
            <div class="col-2">{{ assetComponent.termination.rate }} {{ assetComponent.termination.currencyCode }}</div>
            <div class="col-2">{{ getTerminationFineDate(assetComponent) }}</div>
          </div>
        </div>
      </div>

      <!--      devaluations, expenses-->
      <div class="mt-4" v-if="assetComponent.devaluations.length !== 0">
        <div class="col-8 px-4 py-4 b-full-table__assets-info-wrap">
          <div class="b-contract__card-data-info-about-wrap">
            <div class="row">
              <div class="col-5 b-contract__card-data-info-about-row-name mb-1">
                {{ $t('CONTENT.assets.devaluations') }}
              </div>
            </div>
            <div class="row" v-for="devaluationItem in assetComponent.devaluations">
              <div class="col-2">{{ devaluationItem.sum }} {{ currencyCode }}</div>
              <div class="col-2">{{ devaluationItem.startDate | dateFormatted }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4" v-if="assetComponent.expenses.length !== 0">
        <div class="col-8 px-4 py-4 b-full-table__assets-info-wrap">
          <div class="b-contract__card-data-info-about-wrap mb-2" v-if="expensesContainType('first_expenses')">
            <div class="row">
              <div class="col-5 b-contract__card-data-info-about-row-name mb-1">
                {{ $t('CONTENT.assets.first_expenses') }}
              </div>
            </div>
            <div class="row" v-for="expensesItem in assetComponent.expenses">
              <div class="col-2" v-if="expensesItem.type === 'first_expenses'">{{ expensesItem.sum }}
                {{ currencyCode }}
              </div>
            </div>
          </div>
          <div class="b-contract__card-data-info-about-wrap" v-if="expensesContainType('future_expenses')">
            <div class="row">
              <div class="col-5 b-contract__card-data-info-about-row-name mb-1">
                {{ $t('CONTENT.assets.future_expenses') }}
              </div>
            </div>
            <div class="row" v-for="expensesItem in assetComponent.expenses">
              <div class="col-2" v-if="expensesItem.type === 'future_expenses'">{{ expensesItem.sum }}
                {{ currencyCode }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    several components-->
    <div class="b-full-table__wrapper mx-6 my-4"
         :class="{'mb-4' : isShowPayment, 'b-full-table__wrapper_bb_none' : !isShowPayment}"
         v-if="componentsLength > 1">
      <div class="b-full-table__row" :class="{'b-full-table__row_border_false' : !isShowPayment}">
        <div class="b-full-table__cell b-full-table__cell_type_flex">
          <button class="b-btn b-btn_type_empty b-full-table__edit px-0 b-btn_type_icon_accent_color"
                  @click="showEditAssetComponentModal(assetComponent)"
                  v-if="isContractRawEditing">
            <dynamic-icon class="b-btn__icon" v-tooltip="$t('CONTENT.hints.editAssetComponent')" icon="edit"/>
          </button>
          <button
            class="b-btn b-btn_type_empty b-full-table__edit px-0 b-btn_type_icon_accent_color"
            v-if="isContractChangeConditions && !isContractEventState"
            @click="setItem">
            <dynamic-icon class="b-btn__icon" v-tooltip="$t('CONTENT.hints.changeConditionsAssetComponentHint')" icon="edit"/>
          </button>
          <div
            class="b-full-table__arrow"
            :class="{'b-full-table__arrow_type_open' : isShowPayment}"
            @click="isShowPayment = !isShowPayment"></div>
          <span>
            {{ assetComponent.name }}
            <div class="b-contract__secondary-text"> {{$t('CONTENT.assets.externalId') + ": " + assetComponent.externalId }}</div>
          </span>
        </div>
        <div
          class="b-full-table__cell"
        >{{ assetComponent.quantity }} {{ getUnitOfMeasureName(assetComponent.unitOfMeasureCode) }}
        </div>
        <div class="b-full-table__cell">{{ assetComponent.startDate | dateFormatted }} -
          {{ assetComponent.endDateInitial | dateFormatted }}
        </div>
        <div class="b-full-table__cell b-full-table__cell_type_flex">
          <template v-if="getIsExtension(assetComponent)">
            <dynamic-icon icon="check" class="b-icon_color_blue mr-2"/>
            <div v-if="assetComponent.extension.date !== null">{{ getExtensionDate(assetComponent) }}</div>
            <div v-else>{{ $t('CONTENT.assets.option_true') }}</div>
          </template>
        </div>
        <div class="b-full-table__cell b-full-table__cell_type_flex">
          <template v-if="getIsTermination(assetComponent)">
            <dynamic-icon icon="check" class="b-icon_color_red mr-2"/>
            <div v-if="assetComponent.termination.date !== null">{{ getTerminationDate(assetComponent) }}</div>
            <div v-else>{{ $t('CONTENT.assets.option_true') }}</div>
          </template>
        </div>
        <div class="b-full-table__cell b-full-table__cell_type_flex">
          <template v-if="getIsBuyout(assetComponent)">
            <dynamic-icon icon="check" class="b-icon_color_green mr-2"/>
            <div v-if="assetComponent.buyout.paymentDate !== null">{{ getBuyoutDate(assetComponent) }}</div>
            <div v-else>{{ $t('CONTENT.assets.option_true') }}</div>
          </template>
        </div>
      </div>
      <transition name="fade" v-if="isShowPayment">
        <div>

          <div class="b-full-table__row b-full-table__row-header">
            <div class="b-full-table__cell b-full-table__header-cell">{{ $tc('CONTENT.payments.payment', 1) }}</div>
            <div class="b-full-table__cell b-full-table__header-cell">{{ $t('CONTENT.payments.payment_date') }}</div>
            <div class="b-full-table__cell b-full-table__header-cell">{{ $t('CONTENT.payments.payment_first_date') }}
            </div>
            <div class="b-full-table__cell b-full-table__header-cell">{{ $t('CONTENT.payments.payment_frequency') }}
            </div>
            <div class="b-full-table__cell b-full-table__header-cell">{{ $t('CONTENT.indexation.indexation') }}</div>
            <div class="b-full-table__cell b-full-table__header-cell">{{ $t('CONTENT.payments.discountRateForCell') }}
            </div>
            <div class="b-full-table__cell b-full-table__header-cell b-full-table__cell_type_edit"
                 v-if="isContractRawEditing && notVirtualPaymentsLength > 1"></div>
          </div>
          <div v-for="lessor in assetComponent.lessorComponentShares"
               class="b-contract__card-data-lessor"
               :class="{ 'b-contract__card-data-lessor--red': lessor.isRemove }">
            <div class="row pb-2">
              <div class="col-11 pt-2">
                <div class="b-contract__card-data-lessor-name">{{ $t('CONTENT.payments.payments_for_lessor') }}:
                  <span class="b-contract__card-data-lessor-name--gray">{{ getLesseeName(lessor.lessorId) }}
                    <button
                      v-if="lessor.isNew && !lessor.paymentsParameters.length && isContractEventState"
                      type="button"
                      class="b-btn b-btn_border_none b-btn--right"
                      @click="removeLessorForEvent(lessor)">
                      <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="delete"></dynamic-icon>
                    </button>
                  </span>
                  <div class="b-contract__secondary-text" v-if="!isContractRawEditing && !(isContractEventState && lessor.isNew) && lessor.externalId!==null">id: {{lessor.externalId}}</div>
                  <div class="row pt-2" v-if="isContractRawEditing || (isContractEventState && lessor.isNew)">
                    <div class="col-4">
                      <label>{{ $t("CONTENT.assets.lessorShareExternalId") }}</label>
                      <input type="text" class="b-input" v-model="lessor.externalId" @blur="onLessorComponentShareUpdated"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-1">
                <button type="button" class="b-btn b-btn_border_none ml-auto"
                        @click="()=>removeAssetLessor(lessor.lessorId)"
                        v-if="isContractRawEditing && !isSingleLessorAsset">
                  <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="delete"/>
                </button>
              </div>
            </div>
            <div class="b-contract__card-data-payment" v-for="payment in sortedByFirstPaymentDate(lessor.paymentsParameters)" :key="payment.idInDb">
              <PaymentTableRow
                :payment="payment"
                :assetComponent="assetComponent"
                :lessorComponentShare="lessor"
                :notVirtualPaymentsLength="notVirtualPaymentsLength"
                :unitOfMeasure="getUnitOfMeasureName(assetComponent.unitOfMeasureCode)">
                <div class="b-full-table__cell b-full-table__header-cell">{{ $tc('CONTENT.payments.payment', 1) }}</div>
                <div class="b-full-table__cell b-full-table__header-cell">{{ $t('CONTENT.payments.payment_date') }}
                </div>
                <div class="b-full-table__cell b-full-table__header-cell">
                  {{ $t('CONTENT.payments.payment_first_date') }}
                </div>
                <div class="b-full-table__cell b-full-table__header-cell">
                  {{ $t('CONTENT.payments.payment_frequency') }}
                </div>
              </PaymentTableRow>
            </div>
            <div class="mt-3 mb-1 ml-10" v-if="(isContractRawEditing || (isContractEventState && lessor.isNew)) && (!isInClosedPeriod || currentContract.contract.status === 1)">
              <button type="button" class="b-btn" @click.prevent="addNewPayment(assetComponent.idInDB, lessor)">
                <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
                {{ $tc('CONTENT.payments.payment_create_for_lessor') }}
              </button>
            </div>
            <div class="b-contract_row_flex-end mt-3 mb-1 ml-10 pr-10" v-if="isContractEventState">
              <button
                v-if="!lessor.isEditForEvent && lessor.paymentsParameters.length && !lessor.isNew && !lessor.isRemove"
                type="button"
                class="b-btn end"
                :disabled="lessor.isNotChanges"
                @click="editPaymentsForEvent(lessor)">
                {{ $tc('CONTENT.payments.payments_edit_event') }}
              </button>
              <button
                v-if="lessor.isEditForEvent && lessor.paymentsParameters.length && !lessor.isNew && !lessor.isRemove"
                type="button"
                class="b-btn b-btn--green end"
                @click="acceptPaymentsForEvent(lessor)">
                {{ $tc('CONTENT.payments.payments_accept_event') }}
              </button>
              <checkbox
                v-if="lessor.paymentsParameters.length && !lessor.isNew && !lessor.isRemove"
                class="b-checkbox ml-5 mr-10"
                :disabled="lessor.isEditForEvent"
                v-model="lessor.isNotChanges"
                @change="changedIsNotChanges(lessor)"
              ><span class="text-bold">{{$t('CONTENT.payments.payments_not_changes')}}</span></checkbox>
            </div>
          </div>

          <div v-for="lessor in assetComponent.lessorComponentShares">
            <div v-if="lessor.manualChartPayments.length > 0" class="mt-4">
              <span class="b-contract__card-data-lessor-name">{{ $t('CONTENT.payments.payments_for_lessor') }}:
                <span class="b-contract__card-data-lessor-name--gray">{{ getLesseeName(lessor.lessorId) }}</span>
              </span>
              <div class="b-full-table_type_short my-4 mx-3">
                <div class="b-full-table__row b-full-table__row-header">
                  <div class="b-full-table__cell b-full-table__header-cell b-table__cell_width_md">
                    {{ $tc('CONTENT.payments.payment', 1) }}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-table__cell_width_md">
                    {{ $t('CONTENT.discountRates.discount_rate') }}
                  </div>
                </div>
                <div v-for="manualChartPayment in lessor.manualChartPayments">
                  <ManualChartPaymentTableRow
                    :manualChartPayment="manualChartPayment"/>
                </div>
              </div>
            </div>
          </div>

          <!--    options-->
          <div class="col-8 px-4 mt-1 pb-4 py-4 b-full-table__assets-info-wrap"
               v-if="assetComponent.buyout !== null && assetComponent.buyout.paymentDate !== null || assetComponent.termination !== null && assetComponent.termination.paymentDate !== null">
            <div class="b-contract__card-data-info-about-wrap mb-2"
                 v-if="assetComponent.buyout !== null && assetComponent.buyout.paymentDate !== null">
              <div class="row b-form__container_type_flex">
                <div class="col-2 b-contract__card-data-info-about-row-name mb-1">{{ $t('CONTENT.assets.buyout') }}
                </div>
                <div class="col-2 b-contract__card-data-info-about-row-name mb-1">
                  {{ $t('CONTENT.payments.payment_date') }}
                </div>
              </div>
              <div class="row">
                <div class="col-2">{{ assetComponent.buyout.rate }} {{ assetComponent.buyout.currencyCode }}</div>
                <div class="col-2">{{ getBuyoutDate(assetComponent) }}</div>
              </div>
            </div>
            <div class="b-contract__card-data-info-about-wrap mt-4 mb-2"
                 v-if="assetComponent.termination !== null && assetComponent.termination.paymentDate !== null">
              <div class="row b-form__container_type_flex">
                <div class="col-2 b-contract__card-data-info-about-row-name mb-1">
                  {{ $t('CONTENT.assets.termination') }}
                </div>
                <div class="col-2 b-contract__card-data-info-about-row-name mb-1">
                  {{ $t('CONTENT.payments.payment_date') }}
                </div>
              </div>
              <div class="row">
                <div class="col-2">{{ assetComponent.termination.rate }} {{ assetComponent.termination.currencyCode }}
                </div>
                <div class="col-2">{{ getTerminationFineDate(assetComponent) }}</div>
              </div>
            </div>
          </div>

          <!--    devaluations, expenses-->
          <div class="mt-4" v-if="assetComponent.devaluations.length !== 0">
            <div class="col-8 px-4 py-4 b-full-table__assets-info-wrap">
              <div class="b-contract__card-data-info-about-wrap">
                <div class="row">
                  <div class="col-5 b-contract__card-data-info-about-row-name mb-1">
                    {{ $t('CONTENT.assets.devaluations') }}
                  </div>
                </div>
                <div class="row" v-for="devaluationItem in assetComponent.devaluations">
                  <div class="col-2">{{ devaluationItem.sum }} {{ currencyCode }}</div>
                  <div class="col-2">{{ devaluationItem.startDate | dateFormatted }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4" v-if="assetComponent.expenses.length !== 0">
            <div class="col-8 px-4 py-4 b-full-table__assets-info-wrap">
              <div class="b-contract__card-data-info-about-wrap mb-2" v-if="expensesContainType('first_expenses')">
                <div class="row">
                  <div class="col-5 b-contract__card-data-info-about-row-name mb-1">
                    {{ $t('CONTENT.assets.first_expenses') }}
                  </div>
                </div>
                <div class="row" v-for="expensesItem in assetComponent.expenses">
                  <div class="col-2" v-if="expensesItem.type === 'first_expenses'">{{ expensesItem.sum }}
                    {{ currencyCode }}
                  </div>
                </div>
              </div>
              <div class="b-contract__card-data-info-about-wrap" v-if="expensesContainType('future_expenses')">
                <div class="row">
                  <div class="col-5 b-contract__card-data-info-about-row-name mb-1">
                    {{ $t('CONTENT.assets.future_expenses') }}
                  </div>
                </div>
                <div class="row" v-for="expensesItem in assetComponent.expenses">
                  <div class="col-2" v-if="expensesItem.type === 'future_expenses'">{{ expensesItem.sum }}
                    {{ currencyCode }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!--    create new payment popup-->
    <popup :name="`new-payment-${assetComponent.idInDB}`" height="auto" :scrollable="true">
      <CreatePaymentPopup
        v-if="newPayment"
        :payment="newPayment"
        :lessorComponentShare="lessorComponentShareForCreatePayment"
        :unitOfMeasure="getUnitOfMeasureName(assetComponent.unitOfMeasureCode)"
        :assetComponent="assetComponent"
        @close="closeCreateNewPaymentModal"/>
    </popup>
  </div>
</template>

<script>
import dateConverter from "../../../../utils/converters/date.converter";
import PaymentTableRow from "../../contracts/edit/PaymentTableRow";
import {mapGetters} from "vuex";
import PaymentParameters from "../../../../plugins/assetComponent/models/PaymentParameters";
import CreatePaymentPopup from "./rawEditing/CreatePaymentPopup";
import ManualChartPaymentTableRow from "./ManualChartPaymentTableRow";

export default {
  components: {
    PaymentTableRow,
    ManualChartPaymentTableRow,
    CreatePaymentPopup
  },
  props: ['assetComponent', 'componentsLength'],
  data() {
    return {
      isShowPayment: false,
      assetType: null,
      newPayment: null,
      lessorComponentShareForCreatePayment: null,
    };
  },
  computed: {
    ...mapGetters(["getUnderlyingAssetTypes"]),
    ...mapGetters(["getAssets"]),
    ...mapGetters(["getUnitOfMeasure"]),
    ...mapGetters(["getContractState"]),
    ...mapGetters(["getCurrentContract"]),
    ...mapGetters(["getContractConditionsState"]),
    ...mapGetters(["contractIsInClosedPeriod"]),
    ...mapGetters(["getContractSettings"]),
    ...mapGetters(["allCounterparties"]),
    ...mapGetters(["getContractEventState"]),
    notVirtualPaymentsLength() {
      const result = [];
      this.assetComponent.lessorComponentShares.forEach((lessor) => {
        lessor.paymentsParameters.forEach((payment) => {
          if (!payment.isVirtual) {
            result.push(payment);
          }
        });
      });
      return result.length;
    },
    isInClosedPeriod() {
      return this.contractIsInClosedPeriod;
    },
    currencyCode() {
      return this.getContractSettings.currencyCode;
    },
    isContractChangeConditions() {
      return this.getContractConditionsState;
    },
    isContractRawEditing() {
      return this.getContractState;
    },
    currentContract() {
      return this.getCurrentContract;
    },
    isContractEventState() {
      return this.getContractEventState;
    },
    assetComponentUnitOfMeasure() {
      return this.component.unitOfMeasure;
    },
    isSingleLessorAsset() {
      return this.assetComponent.lessorComponentShares.length === 1
    },
  },
  methods: {
    removeLessorForEvent(lessor) {
      this.assetComponent.lessorComponentShares.forEach((ls, i) => {
        if (ls.idInDB === lessor.idInDB) {
          this.assetComponent.lessorComponentShares.splice(i, 1);
        }
      })
    },
    changedIsNotChanges(lessor) {
      if (lessor.isNotChanges) {
        lessor.paymentsParameters.forEach((payment) => {
          this.$store.commit('ADD_NOT_CHANGE_PAYMENT', payment.idInDB);
        });
      } else {
        lessor.paymentsParameters.forEach((payment) => {
          this.$store.commit('DELETE_NOT_CHANGE_PAYMENT', payment.idInDB);
        });
      }
    },
    editPaymentsForEvent(lessor) {
      lessor.isEditForEvent = true;
    },
    acceptPaymentsForEvent(lessor) {
      lessor.paymentsParameters.forEach((payment) => {
        this.$store.commit('ADD_CHANGED_PAYMENT_LEASE_RATE', {
          paymentParametersId: payment.idInDB,
          newRate: payment.leaseRate,
        });
      }),
      lessor.isEditForEvent = false;
    },
    removeAssetLessor(lessorId) {
      this.$eventBus.$emit('removeAssetLessor', this.assetComponent, lessorId);
    },
    getAssetType(assetTypeId) {
      for (let i = 0; i < this.getUnderlyingAssetTypes.length; i++) {
        if (this.getUnderlyingAssetTypes[i].idInDb === assetTypeId) {
          this.assetType = this.getUnderlyingAssetTypes[i].name;
        }
      }
    },
    getAssetName(assetId) {
      for (let i = 0; i < this.getAssets.length; i++) {
        if (this.getAssets[i].idInDB === assetId) {
          this.getAssetType(this.getAssets[i].underlyingAssetTypeId);
          return this.getAssets[i].name;
        }
      }
    },
    getUnitOfMeasureName(unit) {
      for (let i = 0; i < this.getUnitOfMeasure.length; i++) {
        if (this.getUnitOfMeasure[i].code === unit) {
          return this.$t(`CONTENT.${this.getUnitOfMeasure[i].code}`);
        }
      }
    },
    getIsTermination(component) {
      if (component.termination !== null) {
        return true;
      }
    },
    getIsExtension(component) {
      if (component.extension !== null) {
        return true;
      }
    },
    getIsBuyout(component) {
      if (component.buyout !== null) {
        return true;
      }
    },
    getExtensionDate(component) {
      if (component.extension !== null && component.extension.date !== null) {
        return this.$d(dateConverter.convertToDate(component.extension.date));
      }
    },

    getBuyoutDate(component) {
      if (component.buyout !== null && component.buyout.paymentDate !== null) {
        return this.$d(dateConverter.convertToDate(component.buyout.paymentDate));
      }
    },

    getTerminationDate(component) {
      if (component.termination !== null && component.termination.date !== null) {
        return this.$d(dateConverter.convertToDate(component.termination.date));
      }
    },
    getTerminationFineDate(component) {
      if (component.termination !== null && component.termination.paymentDate.date !== null) {
        let date = dateConverter.convertToDate(component.termination.paymentDate);
        return this.$d(date);
      }
    },
    setItem() {
      this.$eventRegistryManager.editAssetComponentCommands({
        assetComponent: this.assetComponent,
        assetComponentLength: this.componentsLength
      });
    },
    expensesContainType(type) {
      for (let i = 0; i < this.assetComponent.expenses.length; i++) {
        if (this.assetComponent.expenses[i].type === type) {
          return true;
        }
      }

      return false;
    },
    addNewPayment(assetComponentIdInDB, lessorComponentShare) {
      this.newPayment = PaymentParameters.createNew();
      this.lessorComponentShareForCreatePayment = lessorComponentShare;
      this.$modal.show(`new-payment-${assetComponentIdInDB}`);
    },
    closeCreateNewPaymentModal(assetComponentIdInDB) {
      this.$modal.hide(`new-payment-${assetComponentIdInDB}`);
      this.newPayment = null;
    },
    showEditAssetComponentModal(assetComponent) {
      this.$emit('editAssetComponent', assetComponent);
    },
    getLesseeName(lesseeId) {
      for (let i = 0; i < this.allCounterparties.length; i++) {
        if (this.allCounterparties[i].idInDB === lesseeId) {
          return this.allCounterparties[i].displayName;
        }
      }
    },
    sortedByFirstPaymentDate(payments) {
      const sortedPayments = [...payments]

      sortedPayments.sort((p1, p2) => {
        return dateConverter.convertToDate(p1.firstPaymentDate) < dateConverter.convertToDate(p2.firstPaymentDate) ? -1 : 1
      })

      return sortedPayments
    },
    onLessorComponentShareUpdated() {
      this.$emit('onLessorComponentShareUpdated')
    }
  }
};
</script>
